import events from 'events.js';

events.ready().then(() => {
    const iframe = document.getElementById('iframe');
    iframe.addEventListener('load', () => {
        const factsheetElement = iframe.contentDocument.getElementById(
            'factsheets',
        );
        for (let elem of document.querySelectorAll('.theme-color')) {
            events.listen(elem, 'click', (evt) => {
                const val = evt.target.value;
                factsheetElement.className = 'height-md ' + val;
                document.getElementsByClassName('widget-footer')[0].className =
                    'widget-footer ' + val;
            });
        }
    });

    let shouldDisplay = false;
    events.listen(
        document.getElementsByClassName('show-terms')[0],
        'click',
        (evt) => {
            evt.preventDefault();
            shouldDisplay = !shouldDisplay;
            const termsOfService = document.getElementsByClassName(
                'terms-of-service',
            )[0];
            termsOfService.style.display = shouldDisplay ? 'block' : 'none';
        },
    );

    const widgetCode = document.getElementById('get-widget-code');
    events.listen(widgetCode, 'click', () => {
        let colour = 'yellow';
        const colours = Array.from(document.getElementsByTagName('input'));
        for (let colourElem of colours) {
            if (colourElem.name === '0' && colourElem.checked) {
                colour = colourElem.value;
                break;
            }
        }
        var styles = '&lt;style&gt;';
        styles +=
            '.hs-widget-footer {max-width: 284px;margin: auto 8px;padding: 10px 0;text-align: center;position: relative;bottom: 6px;border:1px solid transparent;}';
        styles +=
            '.hs-widget-footer a {color: #444;font-size: 11px;text-decoration:none;}';
        styles +=
            '.hs-widget-footer .footer-hs {background: url(https://www.healthshare.com.au/static/images/sprites-f556b594.svg) 0 0 no-repeat;background-size:177%;width: 105px;height: 16px;display: inline-block;overflow: hidden;}';

        if (colour === 'grey') {
            styles +=
                '.hs-widget-footer.grey {background: #f9f9f9;border-color: #ececec;}';
        } else if (colour === 'yellow') {
            styles +=
                '.hs-widget-footer.yellow {background: #f9f7ed;border-color: #f3efda;}';
        } else if (colour === 'lilac') {
            styles +=
                '.hs-widget-footer.lilac {background: #e8d1e7;border-color: #e0c0de;}';
        } else if (colour === 'blue') {
            styles +=
                '.hs-widget-footer.blue {background: #e2f4f5;border-color: #cfedee;}';
        } else if (colour === 'green') {
            styles +=
                '.hs-widget-footer.green {background: #90ee90;border-color: #8ced8c;}';
        } else if (colour === 'orange') {
            styles +=
                '.hs-widget-footer.orange {background: #ffa500;border-color: #faa200;}';
        } else if (colour === 'pink') {
            styles +=
                '.hs-widget-footer.pink {background: #ffb6c1;border-color: #ffb1bd;}';
        } else if (colour === 'white') {
            styles +=
                '.hs-widget-footer.white {background: #e2f4f5;border-color: #ececec;}';
        }

        styles += '&lt;/style&gt;';
        const height = '420';
        let iframeCode = '<iframe style="border: none; width: 300px"';
        iframeCode += ' height=' + height + '" scrolling="no"';
        iframeCode +=
            ' src="https://www.healthshare.com.au/factsheets/widget/?colour=';
        iframeCode += colour + '"></iframe>';
        iframeCode += '<div class="hs-widget-footer ' + colour + '">';
        iframeCode +=
            '<span class="footer-hs"></span><br><a href="https://www.healthshare.com.au" target="_blank" title="Powered by HealthShare">Powered by HealthShare</a><br><a href="https://www.healthshare.com.au/factsheets/widget-form/" target="_blank" title="Get your free Fact Sheets widget">Get your free Fact Sheets widget</a></div>';

        iframeCode += styles;
        const widgetCopy = document.getElementById('widget-copy');
        widgetCopy.innerHTML = iframeCode;
    });
});
